import { render, staticRenderFns } from "./settlement-sales-summary-detail.vue?vue&type=template&id=5c29b299&scoped=true"
import script from "./settlement-sales-summary-detail.vue?vue&type=script&lang=js"
export * from "./settlement-sales-summary-detail.vue?vue&type=script&lang=js"
import style0 from "./settlement-sales-summary-detail.vue?vue&type=style&index=0&id=5c29b299&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c29b299",
  null
  
)

export default component.exports